import FooterColumnsLayout from './FooterColumnsLayout'

function FooterColumnsLight({ config }) {
  return <FooterColumnsLayout config={config} variant="light" />
}

export default FooterColumnsLight
